"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CertificateIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** CertificateIcon */
var CertificateIcon = function CertificateIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Certificate" : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return _react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), _react.default.createElement(_Icon.Title, null, title), _react.default.createElement(_Icon.Path, {
    d: "M9.001 4.45a3.73 3.73 0 012.925 6.044v5.347L9 14.281l-2.924 1.56v-5.347A3.73 3.73 0 019.002 4.45zm2.027 9.896V11.31a3.712 3.712 0 01-2.027.599c-.747 0-1.444-.22-2.027-.599v3.036l2.027-1.083 2.027 1.083V11.31zM14.658 2c.742 0 1.345.602 1.345 1.345v8.512c0 .744-.603 1.346-1.346 1.346l-1.793-.001v-.897h1.793c.248 0 .449-.2.449-.448V3.345c0-.247-.201-.448-.449-.448H3.345c-.247 0-.448.2-.448.448v8.512c0 .248.2.449.448.449l1.792-.001v.897H3.345A1.345 1.345 0 012 11.858V3.345C2 2.602 2.602 2 3.345 2h11.312zM9 5.347a2.833 2.833 0 100 5.665 2.833 2.833 0 000-5.665z",
    fill: (0, _helpers.color)(props.fill) || (0, _helpers.color)("black100"),
    fillRule: "nonzero"
  }));
};

exports.CertificateIcon = CertificateIcon;
CertificateIcon.displayName = "CertificateIcon";
//# sourceMappingURL=CertificateIcon.js.map